<script>
/**
 * Query string parser for
 * 1. location_id=1435
 * 2. service_id=15
 * 3. provider_id=SA
 * 4. operatory_id=1
 * 5. appointment_length=60
 * 6. appointment_date=2021-03-12
 * 7. appointment_time=08:00:00
 * 8. type=light
 * ?location_id=1435&service_id=15&provider_id=SA&operatory_id=1&appointment_length=60&appointment_date=2021-03-12&appointment_time=08:00:00&type=light
 */

import qs from "query-string";

export default {
  computed: {
    search() {
      if (!location && !location.search && !location.search.length === 0)
        return;
      return qs.parse(location.search, { parseNumbers: true });
    },
  },
  render() {
    return this.$scopedSlots.default({
      search: this.search,
    });
  },
};
</script>
